"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _iconButton = _interopRequireDefault(require("../icon-button"));
var _minusCircle = _interopRequireDefault(require("../../icons/minus-circle"));
var _excluded = ["className", "highContrast"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A minus in a circle button used for removing items.
 */
var RemoveButton = function RemoveButton(_ref) {
  var className = _ref.className,
    highContrast = _ref.highContrast,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_iconButton["default"], _extends({
    className: className,
    highContrast: highContrast,
    path: _minusCircle["default"]
  }, otherProps));
};
RemoveButton.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  /**
   * `aria-label` applied to button.
   */
  ariaLabel: _propTypes["default"].string.isRequired,
  /**
   * optional prop to allow button to be seen more easily on dark backgrounds
   */
  highContrast: _propTypes["default"].bool
} : {};
RemoveButton.displayName = 'RemoveButton';
var _default = exports["default"] = RemoveButton;